import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Computer, Cloud, Users, Cpu, Network, Globe, Grid } from 'lucide-react';
import './services.css';

const ServicesPage = () => {
  const navigate = useNavigate();

  const services = [
    {
      Icon: Computer,
      title: 'LAN',
    //   description: 'Linux | Windows | Scientific Software\nIntel Compilers | MATLAB',
      path: '/services/network/lan',
      isHighlight: false
    },
    {
      Icon: Cloud,
      title: 'WI-FI',
    //   description: 'Management and orchestration\nsoftware for the IITD private cloud.',
      path: '/services/network/wifi',
      isHighlight: false
    },
    {
      Icon: Users,
      title: 'NETWORK ISSUES',
    //   description: 'Revalidation | Suspension | Bulk\nCreation of Users | Forgot Password',
      path: '/services/network/issues',
      isHighlight: false
    },
    {
      Icon: Cpu,
      title: 'NETWORK POLICY',
    //   description: 'The Central Hybrid Supercomputing\nCluster at IITD',
      path: '/services/network/policy',
      isHighlight: false
    },
    {
      Icon: Network,
      title: 'NTP',
    //   description: 'LAN | Wi-Fi | VPN | IITD Proxy | Network Issues | Certificates',
      path: '/services/network/ntp',
      isHighlight: false
    },
    {
      Icon: Globe,
      title: 'WEB SERVICES',
    //   description: 'Web Development | Web Hosting | E-mail Configuration',
      path: '/services/network/web-services',
      isHighlight: false
    },
    {
      Icon: Grid,
      title: 'CERTIFICATES',
    //   description: 'HRMS | Payroll | Leave | Academics | Faculty Recruitment | E-Services',
      path: '/services/network/certificates',
      isHighlight: false
    }
  ];

  const handleServiceClick = (path) => {
    navigate(path);
  };

  return (
    <div className="services-section">
      <div className="container">
        <h2 className="page-title">
        SERVING NETWORK @ <span className="highlight-title">IITD</span>
        </h2>
        
        <p className="section-description text-center">
          The Computer Services Centre provides comprehensive network infrastructure and services to enable seamless connectivity across IIT Delhi campus. Our network services ensure reliable and secure access to academic and administrative resources.
        </p>

        <h3 className="highlights-heading text-center d-flex justify-content-center">SERVICES</h3>

        <div className="row g-4">
          {services.map((service, index) => (
            <div key={index} className="col-md-6 col-lg-3">
              <div
                className="service-card cursor-pointer"
                onClick={() => handleServiceClick(service.path)}
                role="button"
                tabIndex={0}
              >
                <div className="bubble-1"></div>
                <div className="bubble-2"></div>
                <div className="bubble-3"></div>
                
                <div className="card-body text-center">
                  <div className="icon-wrapper">
                    <service.Icon size={24} />
                  </div>
                  <h5 className="card-title">{service.title}</h5>
                  <p className="card-text">
                    {/* {service.description.split('\n').map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        {i === 0 && <br />}
                      </React.Fragment>
                    ))} */}
                  </p>
                  {/* <span className="btn-link">View More...</span> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;